import React, { useEffect, useState, useRef, useContext } from 'react'

import styles from './Empresa.module.css'
import Subtitle from '../Subtitle'

import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const Empresa = ({ contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [girosEmpresa, setGirosEmpresa] = useState([])
    const [stateGirosEmpresa, setStateGirosEmpresa] = useState({})
    const giroRef = useRef()

    const [tamanioRuc, setTamanioRuc] = useState(
        {
            estado: true,
            descripcion: ''
        }
    )

    const handleChangeRazonSocial = (event, campo) => { 
        let valor = event.target.value
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    empresa: {
                        ...state.contratante.empresa,
                        [campo]: valor
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeGiro = (event) => {
        if (event.target.value.length > 2) {
            let giroFilter = girosEmpresa.filter(giro => giro.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) === 0)
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: event.target.value,
                verGiros: true,
                giroFilter: giroFilter
            })
        } else {
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: '',
                verGiros: false,
                giroFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        empresa: {
                            ...state.contratante.empresa,
                            giro: null
                        }
                    }
                }
            })
        }
    }
    const handleGiroClick = (giro) => {
        setStateGirosEmpresa({
            ...stateGirosEmpresa,
            descripcion: giro.valor,
            giro: giro,
            verGiros: false,
            errorSeleccionandoGiro: false
        })
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    empresa: {
                        ...state.contratante.empresa,
                        giro: {
                            codigo: giro.id,
                            descripcion: giro.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    giroEmpresa: true
                }
            }
        })
        giroRef.current.value = giro.valor
    }

    const handleChangeNumerico = (e, campo) => {
        let valor = e.target.value
        const re = /^[0-9\b.,]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        empresa: {
                            ...state.contratante.empresa,
                            [campo]: Funciones.cantidadStringToFloat(valor)
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        ingresoAnualEmpresa: true
                    }
                }
            })
        }
    }

    const handleChangeRuc = (e, campo) => {
        let valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    [campo]: valor,
                    tipoDocumento: {
                        codigo: 2,
                        descripcion: "RUC"
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    numeroRUC: true
                }
            }
        })
    }

    const handleBlurRuc = (e) => {
        let valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")

        if (valor.length < 11) {
            setTamanioRuc({
                estado: false,
                descripcion: 'La longitud no debe ser menor que 11.'
            })
        } else {
            setTamanioRuc({
                estado: true,
                descripcion: ''
            })
        }
    }

    useEffect(() => {
        const cargarCombos = () => {
            setGirosEmpresa(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 7))
        }

        cargarCombos()
    }, [])

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Empresa"
                smostrar="false"
            />
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>Razón Social&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.razonSocial ? styles['logerror'] : null}
                        value={contratante.empresa !== null && contratante.empresa !== undefined
                            ? contratante.empresa.razonSocial || '' : ''}
                        onChange={(e) => handleChangeRazonSocial(e, 'razonSocial')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={130}
                        style={{ textTransform: "capitalize" }}
                    />
                    {!state.campoValidado.razonSocial &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_RAZON_SOCIAL}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Giro&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        style={{ paddingLeft: '3%', textTransform: 'capitalize' }}
                        className={!state.campoValidado.giroEmpresa ? `${styles['logerror']} ${styles['giroEmpresa']}` : styles['giroEmpresa']}
                        defaultValue={contratante.empresa !== null && contratante.empresa !== undefined
                            && contratante.empresa.giro ? contratante.empresa.giro.descripcion : ''}
                        onChange={handleChangeGiro}
                        ref={giroRef}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
                            {stateGirosEmpresa.verGiros
                                ? stateGirosEmpresa.giroFilter.map(giro => (
                                    <div key={giro.id} onClick={event => handleGiroClick(giro)}>
                                        <strong>{giro.valor.substring(0, stateGirosEmpresa.descripcion.length)}</strong>
                                        {giro.valor.substring(stateGirosEmpresa.descripcion.length, giro.valor.length)}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.giroEmpresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_GIRO}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Ingreso anual en S/&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type="text"
                        className={!state.campoValidado.ingresoAnualEmpresa ? styles['logerror'] : null}
                        style={{ paddingLeft: "3.5%" }}
                        maxLength='9'
                        value={contratante && contratante.empresa
                            ? Funciones.formatoMonedaLaboral(contratante.empresa.ingresoAnual) : ''}
                        onChange={(e) => handleChangeNumerico(e, 'ingresoAnual')}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.ingresoAnualEmpresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_INGRESO_ANUAL}</span>
                    }
                </div>
            </div>
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area45']}>
                    <label>Nro. de RUC&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type="text"
                        className={!state.campoValidado.numeroRUC ? styles['logerror'] : null}
                        maxLength='11'
                        value={contratante && contratante.numeroDocumento
                            ? contratante.numeroDocumento || '' : ''}
                        onChange={(e) => handleChangeRuc(e, 'numeroDocumento')}
                        onBlur={(e) => handleBlurRuc(e)}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.numeroRUC &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_RUC}</span>
                    }
                    {!tamanioRuc.estado &&
                        <span className={styles['span-error']}>{tamanioRuc.descripcion}</span>
                    }
                </div>
            </div>
        </div>
    );
}

export default Empresa